<template>
  <div ref="wrapper">
    <slot></slot>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  EsputnikService,
  GoogleEnhancedEcommerce,
  GoogleTagManagerService,
  RtbHouseService
} from '@/services/AnalyticService'

export default {
  name: 'CategoryPage',
  data () {
    return {
      collectedAnalyticsData: []
    }
  },
  props: {
    categoryName: {
      type: String,
      default: ''
    },
    categoryId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      userDataFromServer: state => state.user.user_data
    })
  },
  methods: {
    ...mapActions('microdata', ['APPEND_ITEM_TO_LIST']),
    async sendAnalyticsData () {
      if (GoogleEnhancedEcommerce.isEnabled) {
        if (this.collectedAnalyticsData.length) {
          await GoogleEnhancedEcommerce.viewItemList({
            analyticsData: this.collectedAnalyticsData,
            listId: this.collectedAnalyticsData[0].item_list_id || this.categoryId,
            listName: this.collectedAnalyticsData[0].item_list_name || this.categoryName
          })
          await GoogleEnhancedEcommerce.dinRemViewItemList({
            analyticsData: this.collectedAnalyticsData,
            listName: this.categoryName,
            userId: this.userDataFromServer?.user_id || ''
          })
          this.collectedAnalyticsData = []
        }
      } else {
        if (this.collectedAnalyticsData.length) {
          await GoogleTagManagerService.viewItemListAnalytics({
            analyticsData: this.collectedAnalyticsData,
            listId: this.categoryId,
            listName: this.categoryName
          })
          this.collectedAnalyticsData = []
        }
      }
    },
    collectAnalyticsData (el) {
      this.collectedAnalyticsData.push(el)
    },
    addMicrodata () {
      const categoriesItems = Array.from(document.querySelectorAll('.categories-page__item'))
      if (categoriesItems.length) {
        this.APPEND_ITEM_TO_LIST({
          '@type': 'ItemList',
          'name': this.categoryName || 'Category Page',
          'itemListElement': categoriesItems.map(category => {
            return {
              '@type': 'WebPage',
              'name': category.querySelector('.categories-page__title').innerText,
              'url': category.querySelector('.categories-page__link').href,
              'image': category.querySelector('.categories-page__img').src
            }
          })
        })
      }
    }
  },
  created () {
    if (this.categoryName) {
      EsputnikService.sendCategoryPageInfo({ categoryName: this.categoryName })
      RtbHouseService.CategoryPageCode(this.categoryId)
    }
    if (window.location.pathname.includes('/novynky/')) {
      RtbHouseService.NewOffersPageCode()
    }

    this.addMicrodata()
  },
  mounted () {
    if (window.location.pathname.includes('/novynky/')) {
      sessionStorage.setItem(`listForAnalytics`, `Nowości`)
    } else {
      sessionStorage.setItem(`listForAnalytics`, `Category_Page`)
    }

    const tSafe = (key, fallback) => {
      const value = this.$t(key)
      return !value || value === key ? fallback : value
    }

    const wrapper = this.$refs.wrapper
    const categoryDesc = wrapper.querySelector('.category-description')
    const categoryDescCont = wrapper.querySelector('.category-description__content')
    const categoryDescMoreBth = wrapper.querySelector('.category-description__more')
    const categoryDescMoreBthLabel = wrapper.querySelector('.category-description__more span')
    const isOpen = () => categoryDesc.classList.contains('category-description--open')
    const isTabletView = window.innerWidth > 768
    const isMobileView = !isTabletView

    if ((isMobileView && categoryDescCont.scrollHeight < 400) || (isTabletView && categoryDescCont.scrollHeight < 600)) {
      categoryDescMoreBth.style.display = 'none'
      categoryDesc.classList.add('category-description--open')
    }

    categoryDescMoreBth.addEventListener('click', (_) => {
      categoryDesc.classList.toggle('category-description--open')
      if (isOpen()) {
        categoryDescCont.style.maxHeight = `${categoryDescCont.scrollHeight}px`
        categoryDescMoreBthLabel.textContent = tSafe('seo.main_show_less', 'Hide')
      } else {
        categoryDescCont.removeAttribute('style')
        categoryDescMoreBthLabel.textContent = tSafe('seo.main_show_more', 'Show more')

        categoryDesc.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    })
  },
  watch: {
    collectedAnalyticsData () {
      setTimeout(() => {
        this.sendAnalyticsData()
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
.category-description {
  &__content {
    max-height: 400px;
    position: relative;
    overflow: hidden;
    transition: max-height .3s ease-in-out;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 170px;
      background: linear-gradient(184.44deg, hsla(0, 0%, 100%, 0) 3.61%, hsla(0, 0%, 100%, .469435) 44.84%, #fff 96.39%);
      transition: opacity .3s ease-in-out;
    }
  }

  &__action {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
  }

  &__more {
    padding: 10px 24px 10px 40px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 3px;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #333;
    background: #fff;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 24px;
      height: 24px;
      margin-left: 5px;
    }
  }

  &--open {
    .category-description {
      &__content {
        &:after {
          opacity: 0;
          pointer-events: none;
        }
      }

      &__more {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }

  @media screen and (min-width: 769px) {
    &__content {
      max-height: 600px;
    }
  }
}
</style>
